export const customDocumentFileName = (order, template) => {
    const tourLead = order.services[0]?.travelers?.find(e => e.isTourLead) || order.services[0]?.travelers[0]
    const tourLeadLastName = tourLead?.name[0].lastName?.toUpperCase().replace(' ', '_')
    const dateReverse = new Date().toISOString().slice(0, 10).replace(/-/g, '')
    return `${order.orderId ? order.orderId + '-' : ''}${
        tourLeadLastName ? tourLeadLastName + '-' : ''
    }${template.documentType.replace(' ', '_')}${dateReverse ? '-' + dateReverse : ''}.pdf`
}
